import { useMutation } from "@tanstack/react-query";
import { API_BASE_PATH, API_BASE_RELATIVE_PATH } from "../Config/Config";
import { getUserDetails } from "../utils/userDetailsUtils";
import axios from "axios";

const removeInline = async ({ testStepId, testCaseId }) => {
  const user = getUserDetails();

  const response = await axios.post(
    `${API_BASE_PATH}${API_BASE_RELATIVE_PATH}?action=removeInline&companyid=${user.companyid}&testStepId=${testStepId}&testCaseId=${testCaseId}`,
  );

  return response.data;
};

const useRemoveInline = (options = {}) => {
  return useMutation({
    mutationFn: removeInline,
    ...options,
  });
};

export default useRemoveInline;
